import { AudioManager } from '../../../core/AudioManager';
import { AudioHandle, PositionalOptions } from '../../../core/AudioManager.types';
import { Character } from '../../Character';

export class PistolShootAudio {
    static readonly PRELOAD = ['../assets/sounds/pistol_shoot.mp3'] as const;
    private static readonly SRC = PistolShootAudio.PRELOAD[0];
    private static readonly OPTIONS: PositionalOptions = { volume: 1, loop: false, refDistance: 10 };

    private handle: AudioHandle | null = null;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly character: Character,
    ) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playPositional(PistolShootAudio.SRC, this.character, PistolShootAudio.OPTIONS);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopPositional(this.handle);
        this.handle = null;
    }
}
